/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/payments",
    },
    (router) => {
      router.push({
        id: "@api-legacy/payment@create",
        path: "",
      });

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api-legacy/payment@paybox-config",
            path: "/paybox/config",
          });

          router.push({
            id: "@api-legacy/payment@paybox-direct-debit",
            path: "/paybox/direct/debit",
          });

          router.push({
            id: "@api-legacy/payment@paybox-direct-refund",
            path: "/paybox/direct/refund",
          });
        },
      );
    },
  );
}
